'use strict';

// Third-party modules should reuse the global jQuery bootstrapped by main.js.
var root = typeof window !== 'undefined' ? window : {};

module.exports = root.jQuery || root.$;
